import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Ng-Bootstrap pagination
 * https://ng-bootstrap.github.io/#/components/pagination/api
 */
@Component({
    selector: 'ca-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
    @Input() totalSize: number;
    @Input() currentPage: number;
    @Input() pageSize: number; // Number of items per page
    @Input() pageLink: string;

    @Output() onPageChange: EventEmitter<number> = new EventEmitter();

    _onPageChange(event: number): void {
        // 422337: Only trigger page change if it's not the same page.
        if (!isNaN(event) && this.currentPage !== event) {
            this.onPageChange.emit(event);
        }
    }
}
